import React, { useState ,useEffect } from 'react';
import { Modal, Button, Form, Spinner, Dropdown } from 'react-bootstrap';
import { X, ExclamationTriangle, Router, CheckCircle, XCircle } from 'react-bootstrap-icons';
import { Terminals } from '../../../../../types';
import { updateTerminal} from '../../../../../../../../crud/management_api/terminals';
import { toast } from 'react-toastify';
import { getWorkstationsOptions,WorkstationOption,Terminal_TypesOption, getTerminal_TypesOption } from '../../../utils/utils';
import './UpdateTerminal.scss';

interface UpdateTerminalProps {
    showEditModal: boolean;
    setShowEditModal: (show: boolean) => void;
    setCurrentData: (data: Terminals[]) => void;
    currentData: Terminals[];
    currentTerminal: any;
    }

const UpdateTerminal: React.FC<UpdateTerminalProps> = ({
        showEditModal,
        setShowEditModal,
        setCurrentData,
        currentData,
        currentTerminal
      }) => {
        const [workstations, setWorkstations] = useState<WorkstationOption[]>([]);
        const [terminalTypes, setTerminalTypes] = useState<Terminal_TypesOption[]>([]);
        const [isActive, setIsActive] = useState(true);
        const [WorkstationId, setWorkstationId] = useState('');
        const [TerminalTypeId, setTerminalTypeId] = useState('');
        const [ipAddress, setIpAddress] = useState('');
        const [ipError, setIpError] = useState('');
        const [isUpdating, setIsUpdating] = useState(false);

        // IP validation function
        const validateIP = (ip: string): boolean => {
          if (!ip || ip.trim() === '') return true; // Empty is valid
          
          const trimmedIp = ip.trim();
          
          // IPv4 validation
          const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          
          // IPv6 validation (more comprehensive)
          const ipv6Regex = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::1$|^::ffff:[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$|^::$/;
          
          // Additional IPv6 compressed formats
          const ipv6CompressedRegex = /^([0-9a-fA-F]{1,4}:){1,7}:$|^([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}$|^([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}$|^([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}$|^([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}$|^([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}$|^[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})$/;
          
          return ipv4Regex.test(trimmedIp) || ipv6Regex.test(trimmedIp) || ipv6CompressedRegex.test(trimmedIp);
        };

        const handleIpChange = (value: string) => {
          setIpAddress(value);
          if (value.trim() !== '' && !validateIP(value)) {
            setIpError('Formato de IP inválido. Ingrese una dirección IPv4 o IPv6 válida.');
          } else {
            setIpError('');
          }
        };

        useEffect(() => {
          if (currentTerminal) {
            setIsActive(currentTerminal.state);
            setWorkstationId(currentTerminal.workstation_id);
            setTerminalTypeId(currentTerminal.terminal_type_id);
            setIpAddress(currentTerminal.ip_address || '');
            setIpError(''); // Reset error when loading new terminal
          }
        }, [currentTerminal]);
    
        useEffect(() => {
            getWorkstationsOptions().then((response) => {
                if (response) {
                setWorkstations(response);
                }
            });
            getTerminal_TypesOption().then((response) => {
                if (response) {
                  const activeTerminalTypes = response.filter((terminal: Terminal_TypesOption) => terminal.state === true);
                  setTerminalTypes(activeTerminalTypes);
                }
            });
            }, []);
    
        const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            
            if (isUpdating) return; // Prevent double submission
            
            // Validate IP if provided
            if (ipAddress.trim() !== '' && !validateIP(ipAddress)) {
              setIpError('Formato de IP inválido. Ingrese una dirección IPv4 o IPv6 válida.');
              return;
            }
            
            const form = e.currentTarget;
            if (!form) {
              console.error('Form not found.');
              return;
            }
            
            setIsUpdating(true);
            
            const userContext = localStorage.getItem('user');
            const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
            const ipValue = Number(TerminalTypeId) === 1
              ? (ipAddress.trim() || null)
              : null;
            const updated_terminal: Terminals = {
                terminal_id: currentTerminal.terminal_id,
                terminal_name: form.terminal_name.value,
                terminal_type_id: Number(TerminalTypeId), // Keep existing type
                workstation_id: WorkstationId,
                ip_address: ipValue,
                local_id: localId,
                state: isActive,
                created_at: currentTerminal.created_at
              };
              
              updateTerminal(Number(currentTerminal.terminal_id), updated_terminal)
              .then(response => {
                toast.success('Terminal actualizada con éxito!');
                setShowEditModal(false);
                const updatedData = currentData.map((terminal: Terminals) =>
                  terminal.terminal_id === currentTerminal.terminal_id ? updated_terminal : terminal
                );
                setCurrentData(updatedData);
              })
              .catch(error => {
                console.error('Error al actualizar la terminal:', error);
                toast.error('Error al actualizar la terminal');
              })
              .finally(() => {
                setIsUpdating(false);
              });
         };

         const workstationsDropdown = (
          <div className="form-field">
            <label className="field-label">Estación de trabajo</label>
            <Dropdown>
              <Dropdown.Toggle variant="none" className="dropdown-toggle">
                {workstations.find((w) => String(w.id) === String(WorkstationId))?.name || 'Seleccione una estación'}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {workstations.map((workstation) => (
                  <Dropdown.Item
                    key={workstation.id}
                    onClick={() => setWorkstationId(String(workstation.id))}
                  >
                    {workstation.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );

         // Get device type name for display
         const getDeviceTypeName = () => {
           const deviceType = terminalTypes.find((t) => String(t.id) === String(TerminalTypeId));
           return deviceType ? deviceType.name : 'Tipo de dispositivo';
         };
    
        return (
          <Modal show={showEditModal} onHide={() => setShowEditModal(false)} className="update-terminal-modal">
            <Form onSubmit={handleFormSubmit}>
              <Modal.Header>
                <div className='form-modal-title-container'>
                  <Modal.Title className='form-modal-title'>Actualizar dispositivo</Modal.Title>
                </div>
                <Button variant="none" className="modal-close-button" onClick={() => setShowEditModal(false)}>
                  <X size={24} />
                </Button>
              </Modal.Header>
              <Modal.Body>
                <div className="form-field">
                  <label className="field-label">Nombre</label>
                  <Form.Control 
                    type="text" 
                    name="terminal_name" 
                    placeholder="Nombre del dispositivo" 
                    defaultValue={currentTerminal?.terminal_name} 
                    required 
                  />
                </div>

                <div className="form-field">
                  <label className="field-label">Tipo de dispositivo</label>
                  <div className="device-type-display">
                    <Router className="device-icon" />
                    {getDeviceTypeName()}
                  </div>
                </div>

                {Number(TerminalTypeId) === 1 && (
                  <div className="form-field">
                    <label className="field-label">Dirección IP</label>
                    <Form.Control 
                      type="text" 
                      placeholder="Ej: 192.168.1.100 o 2001:db8::1" 
                      value={ipAddress}
                      onChange={(e) => handleIpChange(e.target.value)}
                      className={ipError ? 'is-invalid' : ''}
                    />
                  </div>
                )}

                {ipError && (
                  <div className="warning-banner">
                    <ExclamationTriangle className="warning-icon" />
                    <div className="warning-content">
                      <div className="warning-title">Formato de IP inválido</div>
                      <div className="warning-message">{ipError}</div>
                    </div>
                  </div>
                )}

                <div className="form-field">
                  <label className="field-label">Estado</label>
                  <button
                    type="button"
                    className={`toggle-button ${isActive ? 'active' : ''}`}
                    onClick={() => setIsActive(!isActive)}
                  >
                    {isActive ? (
                      <>
                        <CheckCircle className="toggle-icon" />
                        Dispositivo activo
                      </>
                    ) : (
                      <>
                        <XCircle className="toggle-icon" />
                        Dispositivo inactivo
                      </>
                    )}
                  </button>
                </div>

                {workstationsDropdown}
              </Modal.Body>
              <Modal.Footer>
                <div className="form-modal-footer-custom">
                  <Button 
                    className="form-button-cancel" 
                    onClick={() => setShowEditModal(false)}
                    disabled={isUpdating}
                  >
                    Cancelar
                  </Button>
                  <Button 
                    className="form-button-create" 
                    type="submit"
                    disabled={isUpdating || !!ipError}
                  >
                    {isUpdating ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Actualizando...
                      </>
                    ) : (
                      'Actualizar'
                    )}
                  </Button>
                </div>
              </Modal.Footer>
            </Form>
          </Modal>
        );
      };


export default UpdateTerminal;

